import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const ModelAdmin = () => (
  <MicroFrontEnd
    name="IdfModelAdmin"
    src={apiConfig.microFrontEnds.ModelAdmin}
  />
)

export default ModelAdmin
